import { render, staticRenderFns } from "./redirectCenter.vue?vue&type=template&id=8b11edb2&scoped=true&"
import script from "./redirectCenter.vue?vue&type=script&lang=js&"
export * from "./redirectCenter.vue?vue&type=script&lang=js&"
import style0 from "./redirectCenter.vue?vue&type=style&index=0&id=8b11edb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b11edb2",
  null
  
)

export default component.exports